import { useMemo, type ReactNode } from 'react';
import { ProductBrandProvider } from '@up2d8/ui';
import { useActiveBrand } from './theme';
import { usePlatformBrand } from './use-platform-brand';

/**
 * Het merk van het product voor de hele app (MRK-2): haalt het platformmerk op
 * (`usePlatformBrand`) en geeft het actieve merk door aan de schil van `@up2d8/ui`, die zelf geen
 * productnaam kent.
 */
export function PlatformBrand({ children }: { children: ReactNode }) {
  usePlatformBrand();
  const brand = useActiveBrand();
  const value = useMemo(
    () => ({
      name: brand.productName,
      splitWordmark: brand.isDefaultProduct,
      logoUrl: brand.productLogoUrl,
    }),
    [brand.productName, brand.isDefaultProduct, brand.productLogoUrl],
  );
  return <ProductBrandProvider value={value}>{children}</ProductBrandProvider>;
}
